/**
 * @namespace source.folders.trash
 */
import { toFolder } from './mappers/folder';
import { toError } from './parsers/error';
import { initFolders } from './folders';
export function initFoldersTrash(settings, http) {
  const folders = initFolders(settings, http);
  function mapFolderList(res) {
    res.data = (res.data.folders || []).map(function (folder) {
      const newFolder = toFolder(folder, settings);
      newFolder.isInTrash = true;
      return newFolder;
    });
    return res;
  }
  function list(folderId, options) {
    options = options || {};
    const queryParams = {
      parent_folder_id: folderId || null,
      trash_type: 'folder'
    };
    if (settings.namespace) {
      queryParams.ns = settings.namespace;
    }
    return http.get(`${settings.apiUrl}/go/site/media/trash/folders`, queryParams, {
      headers: options.headers || {}
    }).then(mapFolderList).catch(toError);
  }
  function search(folderId, query, options) {
    return folders.search(folderId, query, options).then(response => {
      response.data = response.data.map(folder => {
        folder.isInTrash = true;
        return folder;
      });
      return response;
    }).catch(toError);
  }
  return {
    list,
    search
  };
}